import React, { useEffect, useContext, useState, useRef } from "react";
import AuthContext from '../../contexts/Auth'
import EmpresaContext from '../../contexts/Empresa'
import { User } from "../../entities/Security";
import { Notificacao } from "../../entities/Security";
import { useHistory } from "react-router-dom";
// nodejs library that concatenates classes
// @ts-ignore
import classnames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// Função de logout
import { logout } from "../../services/auth";
//API para requests
import api from "../../services/api";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
//@ts-ignore
import NotificacoesLista from "../NotificacoesLista";
// reactstrap components
import Avatar from '../Avatar'
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Navbar,
  NavItem,
  Nav,
  Container,
  Input,
  Button
} from "reactstrap";

interface IAdminNavBar {
  toggleSidenav(): void,
  sidenavOpen: boolean,
  brandText?: string,
  theme: string,
  changeRoutes(routes: any): void,
}

const AdminNavbar: React.FC<IAdminNavBar> = ({ theme, toggleSidenav, sidenavOpen, brandText, changeRoutes }) => {

  const { user, signout } = useContext(AuthContext)
  const { routes } = useContext(EmpresaContext)
  const history = useHistory()

  const [error, setError] = useState('')
  const [name, setName] = useState('')
  const notificationAlert = useRef<NotificationAlert>(null)


  const notify = (type: string, msg: string) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">
            {msg}
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7
    };
    if(notificationAlert?.current) {
      notificationAlert.current.notificationAlert(options);
    }
  };


  const editUser = async (e: React.MouseEvent) => {
    e.preventDefault();
    history.push("/admin/me/edit");
  }



  useEffect(() => {
    changeRoutes(routes)
  }, [routes])



  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      {/* Navbar UI removida para ganhar espaço. A lógica de roteamento foi mantida. */}
    </>
  );
}

export default AdminNavbar;
